import React, { useState } from 'react';
import { useFirebase } from "../providers/firebase";
import { useAuthentication } from "../providers/authentication";
import PopupModal from '../components/PopupModal'; // Import the modal

const PublicationsPage = () => {
    const { publications, publicationsKeys, addPublication, editPublication, deletePublication } = useFirebase();
    const { user } = useAuthentication();
    
    const [isModalVisible, setModalVisible] = useState(false);
    const [currentKey, setCurrentKey] = useState(null);
    const [currentIdx, setCurrentIdx] = useState(null);
    const [defaultValue, setDefaultValue] = useState("");

    const handleEdit = (key, idx) => {
        setCurrentKey(key);
        setCurrentIdx(idx);
        setDefaultValue(publications[key][idx]); // Set default value to edit
        setModalVisible(true);
        editPublication()
    };

    const handleDelete = (key, idx) => {
        console.log(`Delete publication at index ${idx} in ${key}`);
        deletePublication(key, idx)
        .then(() => {
            window.location.reload();
        });
    };

    const handleAdd = (key) => {
        setCurrentKey(key);
        setCurrentIdx(null); // No index for adding new item
        setDefaultValue(""); // Empty input for adding
        setModalVisible(true);
    };

    const handleCloseModal = () => {
        setModalVisible(false);
    };

    const handleSubmit = (value) => {
        if (currentIdx !== null) {
            console.log(`Edit publication at index ${currentIdx} in ${currentKey} with new value: ${value}`);
            editPublication(currentKey, currentIdx, value)
            .then(() => {
                window.location.reload();
            });
        } else {
            console.log(`Add new publication in ${currentKey} with value: ${value}`);
            addPublication(currentKey, value)
            .then(() => {
                window.location.reload();
            });
        }
        setModalVisible(false);
    };

    return (
        <div className="publications-page-container">
            <div className="publications-heading">Publications</div>
            {publications ? (
                <div>
                    <div className="publications-content">
                        {publicationsKeys.map((key, index) => {
                            const items = publications[key];

                            if (Array.isArray(items) && items.length > 0) {
                                return (
                                    <div key={index}>
                                        <div className="line"></div>
                                        <h1 className="publications-type">
                                            {key === "recentConferences"
                                            ? "Recent Publications"
                                            : key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')}

                                            {user && (
                                                <button className="add-btn" onClick={() => handleAdd(key)}>
                                                    Add
                                                </button>
                                            )}
                                        </h1>
                                        <div className="line"></div>
                                        <ul>
                                            {items.map((item, idx) => (
                                                <li className="publications-papers" key={idx}>
                                                    <div className="content-number">{idx + 1}.</div>
                                                    <div className="content">{item}</div>
                                                    {user && (
                                                        <div className="actions">
                                                            <button className="edit-btn" onClick={() => handleEdit(key, idx)}>
                                                                Edit
                                                            </button>
                                                            <button className="delete-btn" onClick={() => handleDelete(key, idx)}>
                                                                Delete
                                                            </button>
                                                        </div>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                );
                            }

                            return null;
                        })}
                    </div>
                </div>
            ) : (
                ""
            )}

            <PopupModal
                show={isModalVisible}
                onClose={handleCloseModal}
                onSubmit={handleSubmit}
                defaultValue={defaultValue}
            />

            <div className="publications-copyright">
                &copy; All Rights Reserved by VSIMA Lab, SECS, IIT Bhubaneswar, 2024
            </div>
        </div>
    );
};

export default PublicationsPage;